<template>
  <div class="container">
    <div
      v-show="message.state"
      class="alert alert-dismissible border-0 fade show"
      :class="message.type"
      role="alert"
    >
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <strong>{{ message.msg }}</strong>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h2 class="card-title">Description and characteristics</h2>
            <br />
            <br />
            <h3>Investment information</h3>
            <br />
            <p class="mb-0">
              Finacial description of the project, where it is located, what it
              consists of, what is going to be built, how many stages have the
              project, how many tokens are going to be issued, what will be the
              the project profitability, construction time details, etc.
            </p>
            <br />
            <textarea
              v-model="asset_information"
              disabled
              class="form-control"
              rows="3"
              placeholder="Enter the investment information here"
            ></textarea>
            <br />
            <br />
            <h3>Investment Characteristics</h3>
            <br />
            <textarea
              v-model="asset_characteristics"
              disabled
              class="form-control"
              rows="3"
              placeholder="Enter the investment characteristics here"
            ></textarea>
            <br />
            <br />
            <h3>Project Details</h3>
            <br />
            <p class="mb-0">
              Business details, where it is located, location advantages, design
              features, how many rooms it have, the dimensions of the property,
              dimensions of the asset, etc.
            </p>
            <br />
            <textarea
              v-model="asset_details"
              disabled
              class="form-control"
              rows="3"
              placeholder="Enter the project details here"
            ></textarea>
            <br />
            <br />
            <div class="text-right">
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as move_tabs from './js/movetabs.js';
export default {
  name: 'AssetDescription',
  components: {},

  data() {
    return {
      message: {
        state: false,
        msg: '',
        type: '',
      },
      asset_name: '',
      asset_information: '',
      asset_characteristics: '',
      asset_details: '',
      assetId: '5f864b91f3796a00175b977b',
      userId: '',
    };
  },
  created() {
    this.userId = JSON.parse(localStorage.getItem('user')).userId;
    this.assetId = this.$store.state.assetId;
    this.complete_description();
  },
  methods: {
    complete_description() {
      this.$http
        .get(`/asset/description/Data?assetId=${this.assetId}`)
        .then(({ data }) => {
          this.assetId = data.Description._id;
          this.asset_information = data.Description.information;
          this.asset_details = data.Description.details;
          this.asset_characteristics = data.Description.characteristics;
          this.userId = data.Description.userId;
        })
        .catch(err => {
          this.message.msg = err.response.data.message;
          this.message.type = 'alert-warning';
          this.message.state = true;
          this.scrollNavigator();
          return;
        });
    },
    changeTabAndNextStep() {
      // wait 2 seconds to change the panel and move the step-bar
      setTimeout(() => {
        this.$emit('update', 3);
        move_tabs.moveTab();
      }, 2000);
    },
    scrollNavigator() {
      // scroll to the top of the browser
      // so that the user can view the alert
      window.scroll({
        top: -5000,
        behavior: 'smooth',
      });
    },
    emptyFields() {
      return (
        this.asset_information == '' ||
        this.asset_characteristics == '' ||
        this.asset_details == ''
      );
    },
  },
};
</script>
